const MODULE = {
  state: {
    privateThoughts: [],
    publicThoughts: []
  },

  mutations: {

    setPublicThoughts (state, publicThoughts) {
      state.publicThoughts = publicThoughts
    },

    setPrivateThoughts (state, privateThoughts) {
      state.privateThoughts = privateThoughts
    },

    makeThoughtPublic (state, privateThought) {
      const index = state.privateThoughts.findIndex(t => t.uuid === privateThought.uuid)
      if (index > -1) {
        state.privateThoughts.splice(index, 1)
        state.publicThoughts.unshift(privateThought)
      }
    },

    setThoughtPin (state, { thoughtIndex, userId }) {
      state.publicThoughts[thoughtIndex].pins.push(userId)
    },

    setThoughtUnpin (state, { thoughtIndex, userId }) {
      const index = state.publicThoughts[thoughtIndex].pins.indexOf(userId)
      if (index > -1) {
        state.publicThoughts[thoughtIndex].pins.splice(index, 1)
      }
    }
  },

  actions: {
    requestAllThoughts: async (context) => {
      if (context.rootState.challenge.currentlyViewedChallenge !== null) {
        // gets and sets all thoughts for the activated challenge
        const endpoint = '/api/v1/thought'
        const queryParams = {
          challenge: context.rootState.challenge.currentlyViewedChallenge.uuid
        }

        const allThoughts = await context.dispatch('authorizedFetch', {
          method: 'GET',
          endpoint: endpoint,
          queryParams: queryParams
        }, { root: true })

        const publicThoughts = allThoughts.thoughts.filter(t => t.public === true)
        const privateThoughts = allThoughts.thoughts.filter(t => t.public === false)

        context.commit('setPublicThoughts', publicThoughts)
        context.commit('setPrivateThoughts', privateThoughts)
      }
    },

    requestCreatePrivateThought: async (context, text) => {
      const endpoint = '/api/v1/thought'
      const body = {
        challenge: context.rootState.challenge.currentlyViewedChallenge.uuid,
        public: false,
        content: text,
        pins: []
      }

      await context.dispatch('authorizedFetch', {
        method: 'POST',
        endpoint: endpoint,
        body: body
      }, { root: true })
    },

    requestMakeThoughtPublic: async (context, thought) => {
      const endpoint = `/api/v1/thought/${thought.uuid}`
      const body = {
        public: true,
        content: thought.content
      }

      await context.dispatch('authorizedFetch', {
        method: 'PUT',
        endpoint: endpoint,
        body: body
      }, { root: true })

      context.commit('makeThoughtPublic', thought)
    },

    moveThoughtToParkingLot: async (context, thought) => {
      // delete thought
      await context.dispatch('authorizedFetch', {
        method: 'DELETE',
        endpoint: `/api/v1/thought/${thought.uuid}`
      }, { root: true })

      // create hmw in the parking lot
      await context.dispatch('authorizedFetch', {
        method: 'POST',
        endpoint: '/api/v1/hmw',
        body: {
          challenge: context.rootState.challenge.currentlyViewedChallenge.uuid,
          content: thought.content
        }
      }, { root: true })
    },

    requestToggleThoughtPin: async (context, thoughtToToggle) => {
      const endpoint = `/api/v1/thought/${thoughtToToggle.uuid}/toggle`

      console.log(thoughtToToggle)
      context.rootState.event.socket.send({
        time: new Date().toISOString(),
        type: 'refreshThought',
        sender: '',
        senderName: '',
        payload: ''
      })

      await context.dispatch('authorizedFetch', {
        method: 'PUT',
        endpoint: endpoint
      }, { root: true })

      // update frontend state
      const thoughtIndex = context.state.publicThoughts.findIndex(t => t.uuid === thoughtToToggle.uuid)
      if (thoughtIndex !== -1) {
        const thought = context.state.publicThoughts[thoughtIndex]
        const userId = context.rootState.auth.userInfo.uuid
        const isPinned = thought.pins.includes(userId)

        if (isPinned) {
          context.commit('setThoughtUnpin', {
            thoughtIndex: thoughtIndex,
            userId: userId
          })
        } else {
          context.commit('setThoughtPin', {
            thoughtIndex: thoughtIndex,
            userId: userId
          })
        }
      }
    }
  }
}

export default MODULE
